import React from "react"

export default function CloudIcon() {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clipCloudIcon)">
        <path
          className="white-fill"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.531 15.2908C55.7023 16.1768 59.6377 20.6817 59.6377 26.1057C59.6377 32.166 54.725 37.0787 48.6648 37.0787H11.4164C5.35615 37.0787 0.443359 32.166 0.443359 26.1057C0.443359 21.1018 3.79277 16.8802 8.37194 15.5606C9.8445 9.83376 15.0425 5.60186 21.2288 5.60186C21.6013 5.60186 21.9702 5.6172 22.3349 5.64728C25.2712 2.19216 29.6488 0 34.5384 0C43.1391 0 50.1557 6.78263 50.531 15.2908Z"
          fill="#4996FF"
        />
        <rect
          className="white-fill"
          x="28.2876"
          y="40.191"
          width="3.63825"
          height="5.53428"
          fill="#4996FF"
        />
        <rect
          className="white-fill"
          x="45.7759"
          y="52.8303"
          width="3.63826"
          height="7.0357"
          transform="rotate(90 45.7759 52.8303)"
          fill="#4996FF"
        />
        <rect
          className="white-fill"
          x="21.2866"
          y="52.8303"
          width="3.63826"
          height="7.0357"
          transform="rotate(90 21.2866 52.8303)"
          fill="#4996FF"
        />
        <circle
          className="white-fill"
          cx="54.5961"
          cy="54.6493"
          r="5.43054"
          fill="#4996FF"
        />
        <ellipse
          className="white-fill"
          cx="5.43054"
          cy="54.6493"
          rx="5.43054"
          ry="5.43054"
          fill="#4996FF"
        />
        <path
          className="white-fill"
          d="M24.6763 50.5462C24.6763 49.8131 25.2706 49.2188 26.0037 49.2188H34.2099C34.943 49.2188 35.5373 49.8131 35.5373 50.5462V58.7525C35.5373 59.4856 34.943 60.0799 34.2099 60.0799H26.0037C25.2706 60.0799 24.6763 59.4856 24.6763 58.7525V50.5462Z"
          fill="#4996FF"
        />
      </g>
      <defs>
        <clipPath id="clipCloudIcon">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
